import React, { FC } from 'react';
import { useParams } from 'react-router';
import PrometheusCount from './PrometheusCount';
import { MonitoringDateRange } from '../../monitoring/DateRange-Dropdown-util';

interface NumberOfFeatureViewsAndTablesMaterializedProps {
  monitoringDateRange: MonitoringDateRange;
}

const NumberOfFeatureViewsAndTablesMaterialized: FC<NumberOfFeatureViewsAndTablesMaterializedProps> = ({
  monitoringDateRange,
}) => {
  const chartTitle = 'Materialized';
  const { workspace } = useParams();

  const queries = [
    {
      label: 'Total',
      query: `sum by (tecton_cluster) (feature_package_materialization_enabled{workspace=~'${workspace}',tecton_cluster=~'.*', aws_region=~'.*'}) OR on() vector(0)`,
    },
  ];

  return (
    <div>
      <PrometheusCount
        chartTitle={chartTitle}
        monitoringDateRange={monitoringDateRange}
        queries={queries}
        parseCallback={parseInt}
      />
    </div>
  );
};

export default NumberOfFeatureViewsAndTablesMaterialized;
